import en from './en';

const de = {
  ...en,
  lang: 'de',
  langName: 'Deutsch',
  flag: '🇩🇪',
  siteTitle: 'Kostenlose TOEFL iBT Probetests - KI-Analyse | Power TOEFL 2026',
  siteDescription: 'Übe die neuesten TOEFL-Tests 2026 kostenlos mit KI-Analyse für Reading, Listening, Speaking und Writing.',
  ogTitle: 'Kostenlose TOEFL iBT Probetests - KI-Analyse | Power TOEFL 2026',

  navGrammar: 'Grammatik',
  navPractice: 'Teiltraining',
  navScoreChart: 'Punktetabelle',
  navVocabulary: 'Wortschatz',
  navTips: 'Tipps & Strategie',
  navFAQ: 'FAQ',
  navReading: 'Lesen',
  navListening: 'Hören',
  navSpeaking: 'Sprechen',
  navWriting: 'Schreiben',
  navQuestionPool: 'Fragenbank',
  navResources: 'Ressourcen',
  navPremium: 'Premium-Abo',

  loginButton: 'Anmelden',
  wrongAnswers: 'Fehlernotizen',
  logout: 'Abmelden',
  loginRequired: 'Für Fehlernotizen und Fortsetzen ist eine Anmeldung erforderlich.',

  heroBadge: 'Premium-TOEFL-Lernsystem',
  moreTools: 'Weitere Lernwerkzeuge',
  practiceLabel: 'Teiltraining',
  practiceDesc: 'Reading und Listening separat üben',
  scoreChartLabel: 'Punkteumrechnung',
  scoreChartDesc: 'Richtige Antworten zur Punktzahl',
  vocabLabel: 'Wortschatz',
  vocabDesc: 'Wichtige TOEFL-Vokabeln',
  tipsLabel: 'Tipps & Strategie',
  tipsDesc: 'Strategien für Reading und Listening',
  catLabel: 'CAT Adaptiver Test',
  catDesc: 'Der Schwierigkeitsgrad passt sich automatisch an',
  guideLabel: 'Lernleitfäden',
  guideDesc: 'Strategien nach Fähigkeit und Zielpunktzahl',
  grammarSectionTitle: 'Englische Grammatik',
  grammarSectionDesc: 'Baue deine Grammatik Schritt für Schritt auf',
  grammarViewAll: 'Alle anzeigen',

  footerMockTest: 'Üben',
  footerQuestionPool: 'Fragenbank',
  footerPractice: 'Teiltraining',
  footerStudy: 'Lernen',
  footerBooks: 'Empfohlene Bücher',
  footerEtc: 'Mehr',
  footerLC: 'Listening-Übung',
  footerRC: 'Reading-Übung',
  footerSpeaking: 'Speaking-Übung',
  footerWriting: 'Writing-Übung',
  footerLCStrategy: 'Listening-Strategie',
  footerRCStrategy: 'Reading-Strategie',
  footerGuide: 'Lernleitfaden',
  footerPrivacy: 'Datenschutz',
  footerTerms: 'Nutzungsbedingungen',
  footerRefund: 'Rückerstattung',
  footerAbout: 'Über uns',
  footerCopyright: '© 2026 Power TOEFL. Alle Rechte vorbehalten.',
  footerDisclaimer: 'TOEFL® ist eine eingetragene Marke von ETS. Power TOEFL ist unabhängig und nicht mit ETS verbunden.',

  heroTitle1: 'Eine Plattform',
  heroTitle2: 'für Ihren TOEFL-Erfolg',
  heroDesc1: 'Von realistischen Mock Tests bis zur persönlichen Fehleranalyse,',
  heroDesc2: 'alles an einem Ort für Ihr Ziel.',
  fullTestCardLabel: 'Volltest',
  fullTestCardDesc: 'Realistische Reading- und Listening-Simulation',
  proBadgeLabel: 'Pro',
  googleLogin: 'Mit Google starten',

  pwaAddToHome: 'Zur Startseite hinzufügen',
  pwaAddToHomeDesc: 'Öffnen Sie Power TOEFL schneller wie eine App.',
  pwaInstall: 'Installieren',
  pwaIOSGuide: 'Teilen',

  resumeTest: 'Fortsetzen',
  resumeDesc: '{0} Runde {1} — {2}/{3} Fragen',
  progressLabel: 'Fortschritt',
  timerLabel: 'Verbleibende Zeit',
  timeUp: 'Zeit abgelaufen!',
  navHome: 'Startseite',
  navSettings: 'Tipps',

  speakingPageH1: 'TOEFL Speaking üben',
  speakingPageDesc: 'Üben Sie alle Speaking-Aufgaben mit Aufnahme und KI-Feedback.',
  writingPageH1: 'TOEFL Writing üben',
  writingPageDesc: 'Trainieren Sie Build a Sentence, Email und Academic Discussion.',
  grammarBookTitle: 'TOEFL-Grammatik',
  grammarCourseName: 'Englische Grammatik für TOEFL',
  grammarBreadcrumb: 'Grammatik',

  statsTitle: 'Lernstatistik | Power TOEFL',
  statsDesc: 'Überprüfen Sie Ihren Fortschritt, Ihre Schwächen und Ihre wöchentliche Aktivität.',
  statsH1: 'Meine Lernstatistik',
  statsLoginPrompt: 'Melden Sie sich an, um Ihre persönlichen Statistiken zu sehen.',
  statsLast7Days: 'Letzte 7 Tage',
  statsTotalWrong: 'Falsche Antworten',

  leaderboardTitle: 'Lernrangliste',
  leaderboardWeekly: 'Wöchentlich',
  leaderboardMonthly: 'Monatlich',
  leaderboardLoading: 'Wird geladen...',
  leaderboardEmpty: 'Noch keine Daten für diesen {period}.',
  leaderboardEmptyWeek: 'Zeitraum',
  leaderboardEmptyMonth: 'Monat',
  leaderboardHint: 'Lösen Sie Tests und erscheinen Sie automatisch im Ranking!',
  leaderboardRank: 'Rang',
  leaderboardNickname: 'Name',
  leaderboardSolved: 'Gelöst',
  leaderboardAccuracy: 'Genauigkeit',
  leaderboardMe: 'Ich',

  pricingTitle: 'Power TOEFL Pro Preise — €12,99/Monat | Free vs. Premium | 2026',
  pricingDesc: 'Vergleichen Sie den kostenlosen Plan mit Pro: unbegrenzte Übung, KI-Analyse, ausführliche Erklärungen und weniger Ablenkung beim TOEFL-Lernen.',
  pricingLoginRequired: 'Bitte melden Sie sich an, um fortzufahren.',
  pricingPaymentError: 'Bei der Zahlung ist ein Fehler aufgetreten.',
  pricingPaymentCancelled: 'Die Zahlung wurde abgebrochen.',
  pricingFaqQ1: 'Was ist der Unterschied zwischen Free und Pro?',
  pricingFaqA1: 'Pro bietet unbegrenzte Fragen, detaillierte Erklärungen und KI-Analyse.',
  pricingFaqQ2: 'Kann ich eine Rückerstattung erhalten?',
  pricingFaqA2: 'Aufgrund der Natur digitaler Produkte sind Rückerstattungen grundsätzlich nicht verfügbar. In Ausnahmefällen kann eine Rückerstattung jedoch gewährt werden, wenn dies gesetzlich erforderlich ist, bei Doppelbelastung, Nichtbereitstellung der Leistung oder schwerwiegenden technischen Störungen.',
  pricingFaqQ3: 'Wie kann ich mein Abo kündigen?',
  pricingFaqA3: 'Sie können Ihr Abo jederzeit auf der Zahlungsplattform verwalten.',
  pricingFaqQ4: 'Was ist der Unterschied zwischen Jahresplan und Lifetime?',
  pricingFaqA4: 'Der Jahresplan wird jährlich berechnet; Lifetime ist eine einmalige Freischaltung, wenn verfügbar.',

  aboutCtaHeading: 'Jetzt starten',
  aboutCtaDesc: 'Beginnen Sie mit einem kostenlosen TOEFL-Probetest.',
  aboutCtaStart: 'Kostenlos testen',
  aboutCtaPricing: 'Premium ansehen',

  // --- Auto-translated UI strings ---
  lcTitle: "Hören",
  lcSubtitle: "Hören – 28 Fragen",
  lcTime: "36 Min.",
  rcTitle: "Lesen",
  rcSubtitle: "Lesen – 20 Fragen",
  rcTime: "35 Min.",
  startTest: "Test starten",
  fullTestStart: "Kompletten Probetest starten (Lesen -> Hören)",
  fullTestDesc: "Beide Abschnitte nacheinander absolvieren",
  part1: "Akademisches Lesen (20)",
  part2: "Konversationen (10)",
  part3: "Vorlesungen (18)",
  statQuestions: "Fragen",
  statParts: "Teile",
  statMinutes: "Minuten",
  faqTitle: "Häufig gestellte Fragen",
  faqDesc: "Finden Sie Antworten zu TOEFL und Power TOEFL.",
  faqPageTitle: "TOEFL Anmeldung, Ergebnis, Gültigkeit – 2026 FAQ | Power TOEFL",
  faqPageDesc: "Anmeldung, Ergebnisumrechnung, Gültigkeit und Abschnittsstrategie auf einer Seite.",
  faqMore: "Brauchen Sie mehr Hilfe? Wir aktualisieren diese FAQ ständig.",
  scoreChartPageTitle: "TOEFL Ergebnisumrechnung 2026 – Abschnittsergebnisse sofort prüfen | Power TOEFL",
  scoreChartPageDesc: "TOEFL-Abschnittsergebnisumrechnung für Lesen, Hören, Sprechen, Schreiben. Geben Sie die richtigen Antworten für eine geschätzte Punktzahl und Zielvorgaben ein.",
  scoreChartHeading: "TOEFL Ergebnisumrechnungstabelle",
  scoreChartIntro: "Die Tabellen mit 0–30 je Abschnitt und 0–120 gesamt sind Power-TOEFL-Lernschätzungen auf der alten/vergleichbaren Skala. Offizielle Berichte 2026 führen Abschnitts- und Gesamtwerte von 1–6 in 0,5-Schritten.",
  scoreChartLC: "Lese-Umrechnung",
  scoreChartRC: "Hör-Umrechnung",
  scoreChartCorrect: "Richtig",
  scoreChartConverted: "Umrechnungs-Punktzahl",
  scoreChartUnit: "",
  scoreChartPointUnit: "Pkt.",
  scoreGuideTitle: "Anleitung zur Zielpunktzahl",
  scoreGuide900: "Spitzenklasse",
  scoreGuide900Desc: "Ziel sind 28+ Punkte pro Abschnitt. Stark für Top-Zulassungen.",
  scoreGuide800: "Obere Klasse",
  scoreGuide800Desc: "Ziel sind 22+ Punkte pro Abschnitt. Erfüllt die meisten Zulassungsanforderungen.",
  scoreGuide700: "Gehobenes Mittel",
  scoreGuide700Desc: "Akademische Grundkenntnisse erreicht. Bedingte Zulassung möglich.",
  scoreGuide600: "Mittelstufe",
  scoreGuide600Desc: "Konzentrieren Sie sich zuerst auf die Grundlagen des Lesens und Hörens.",
  scoreChartFaqTitle: "TOEFL-Punkte-FAQ",
  scoreChartCtaTitle: "Überprüfen Sie jetzt Ihr Niveau",
  scoreChartCtaDesc: "Machen Sie einen kostenlosen TOEFL-Probetest und schätzen Sie Ihre Punktzahl ein.",
  scoreReadingHeader: "Lesen (0-30 Pkt.)",
  scoreListeningHeader: "Hören (0-30 Pkt.)",
  scoreSpeakingHeader: "Sprechen (0-30 Pkt.)",
  scoreWritingHeader: "Schreiben (0-30 Pkt.)",
  scoreSpeakingDesc: "4 Aufgaben werden auf einer Skala von 0-4 bewertet und dann in 30 Punkte umgerechnet",
  scoreWritingDesc: "2 Aufgaben werden auf einer Skala von 0-5 bewertet und dann in 30 Punkte umgerechnet",
  vocabPageTitle: "600 häufige TOEFL-Wörter – Bedeutungen und Beispiele | Power TOEFL",
  vocabPageDesc: "Lernen Sie 600 TOEFL-Wörter nach Kategorien mit sofortigen Bedeutungen und Beispielen.",
  vocabHeading: "Wesentlicher TOEFL-Wortschatz",
  vocabIntro: "Lernen Sie unverzichtbaren Wortschatz nach Kategorien. Klicken Sie, um Bedeutungen anzuzeigen.",
  vocabShowAll: "Alle anzeigen",
  vocabHideAll: "Alle ausblenden",
  vocabReset: "Zurücksetzen",
  vocabClickToReveal: "Klicken, um Bedeutung anzuzeigen",
  vocabMotivation: "Konstante Wiederholung erhöht Ihre TOEFL-Punktzahl.",
  vocabMyWords: "Mein Wortschatz",
  vocabAddWord: "Wort hinzufügen",
  vocabAddWordPlaceholder: "Englisches Wort eingeben",
  vocabMyWordsEmpty: "Noch keine Wörter hinzugefügt. Fügen Sie Ihr erstes Wort oben hinzu.",
  vocabDeleteWord: "Löschen",
  vocabLookingUp: "Suchen...",
  vocabQuizTitle: "Vokabel-Quiz",
  vocabQuizDesc: "Testen Sie Synonyme und Antonyme von gelernten Wörtern.",
  vocabQuizMode_synonym: "Synonym-Quiz",
  vocabQuizMode_antonym: "Antonym-Quiz",
  vocabQuizMode_mixed: "Gemischtes Quiz",
  vocabQuizClose: "Schließen",
  vocabQuizNoQuestions: "Noch nicht genügend Quizfragen in dieser Kategorie vorhanden.",
  vocabQuizBack: "Zurück",
  vocabQuizResult: "Quiz-Ergebnis",
  vocabQuizExcellent: "Ausgezeichnet!",
  vocabQuizGood: "Großartige Arbeit. Mit etwas mehr Übung sind Sie bereit.",
  vocabQuizKeepGoing: "Weiter so!",
  vocabQuizRetry: "Wiederholen",
  vocabQuizFindSynonym: "Wählen Sie ein Synonym für das folgende Wort",
  vocabQuizFindAntonym: "Wählen Sie ein Antonym für das folgende Wort",
  vocabQuizNext: "Weiter",
  vocabQuizFinish: "Ergebnis ansehen",
  vocabQuizStart: "Quiz starten",
  vocabCatNaturalScience: "Naturwissenschaft",
  vocabCatSocialScience: "Sozialwissenschaft",
  vocabCatHumanities: "Geisteswissenschaften",
  vocabCatLifeScience: "Biowissenschaften",
  vocabCatTechnology: "Technologie/Ingenieurwesen",
  vocabCatAcademicGeneral: "Allgemein akademisch",
  tipsLCPageTitle: "Wie man den TOEFL-Hörverstehenswert steigert | LC-Trainingsroutine - Power TOEFL",
  tipsLCPageDesc: "Praktisches TOEFL-Hörverstehenstraining für höhere LC-Werte: Notizen machen für Gespräche und Vorlesungen, Schlussfolgerungen und Fragen zur Einstellung des Sprechers.",
  tipsLCHeading: "Strategie für den TOEFL-Hörverstehenswert",
  tipsLCIntro: "Zentrale Strategien und praktische Routinen für jeden Teil des TOEFL-Hörverständnisses.",
  tipsLCPractice: "Hörverständnis jetzt üben",
  tipsLCPracticeDesc: "Wenden Sie die Strategie mit einem echten Übungstest an.",
  tipsLCStartTest: "Hörverständnistest starten",
  tipsRCPageTitle: "TOEFL Lesestrategie – Akademisches Passage Handbuch | Power TOEFL",
  tipsRCPageDesc: "TOEFL-Lesestrategie für akademische Passagen: Zeiteinteilung, Schlussfolgerungen und Ansatz bei Zusammenfassungsfragen.",
  tipsRCHeading: "TOEFL Lesestrategie",
  tipsRCIntro: "Ein praktischer Leitfaden zur Strategie und Zeiteinteilung für TOEFL-Lesepassagen.",
  tipsRCPractice: "Lesen jetzt üben",
  tipsRCPracticeDesc: "Wenden Sie die Strategie mit einem echten Übungstest an.",
  tipsRCStartTest: "Lesetest starten",
  tips7DayTitle: "7-Tage Last-Minute-Lernplan",
  tips7DayDesc: "Maximieren Sie Ihre Punktzahl mit einer zielgerichteten Routine für die letzte Woche",
  tipsTrapTitle: "Leitfaden für Fallenmuster",
  tipsTrapDesc: "Lernen Sie die 5 häufigsten Fallenmuster im Voraus kennen",
  aboutPageTitle: "Über Power TOEFL – Kostenlose TOEFL-Probetests und KI-Lernwerkzeuge",
  aboutPageDesc: "Üben Sie TOEFL mit vollständigen Probetests, KI-Schwächenanalyse und automatischer Überprüfung falscher Antworten. Erfahren Sie, was Power TOEFL bietet.",
  aboutHeading: "Power TOEFL – Praktische TOEFL-Vorbereitungsplattform",
  aboutS1Title: "Was ist Power TOEFL?",
  aboutS1Body: "Power TOEFL ist eine kostenlose Online-Plattform für Lernende, die sich auf den TOEFL vorbereiten. Wir bieten vollständige Probetests, KI-gestützte Übungen und Tools zur Überprüfung falscher Antworten.",
  aboutS2Title: "Für wen ist es?",
  aboutS2Body: "Empfohlen für Studenten, die sich auf den TOEFL für die Zulassung vorbereiten, für Fachkräfte, die die erforderlichen Punktzahlen anstreben, und für unabhängige Lernende, die strukturierte Übungen wünschen.",
  aboutS3Title: "Hauptmerkmale",
  aboutFeature1: "Vollständige Probetests im TOEFL-Stil mit mehreren Runden",
  aboutFeature2: "Abschnittsspezifische Übungen für Lesen, Hören, Sprechen und Schreiben",
  aboutFeature3: "KI-gestützte Aufgabengenerierung und Schwächenanalyse",
  aboutFeature4: "Automatisches Notizbuch für falsche Antworten mit regelmäßiger Wiederholung",
  aboutFeature5: "Punktzahl-Umrechnungstabelle und essentielles TOEFL-Vokabular",
  aboutS4Title: "Kostenlos vs. Premium",
  aboutS4Body: "Kostenlos beinhaltet Probetests, Abschnittsübungen und Punktzahl-Umrechnung. Premium bietet unbegrenzte KI-Generierung, werbefreies Lernen und vollen Mock-Zugang.",
  aboutS5Title: "Warum die Punktezahl steigt",
  aboutS5Body: "Mit Spaced Repetition, gezielter Schwächenanalyse und realistischen Übungsbedingungen können Lernende im Laufe der Zeit eine stabile Prüfungsleistung aufbauen.",
  aboutS6Title: "Beziehung zu ETS",
  aboutS6Body: "Power TOEFL ist eine unabhängige Lernplattform und ist weder mit ETS verbunden noch von ETS unterstützt. TOEFL ist eine eingetragene Marke von ETS.",
  aboutS7Title: "Kontakt",
  aboutS7Body: "Für Serviceanfragen kontaktieren Sie skdaks0731@gmail.com.",
  catPageTitle: "TOEFL Adaptiver Test (CAT) – Auto-Schwierigkeit durch KI | Power TOEFL",
  catPageDesc: "TOEFL Computer-adaptiver Übungstest. KI passt die Aufgabenschwierigkeit basierend auf Ihrer Leistung automatisch an.",
  catHeading: "Adaptiver Test (CAT)",
  catIntro: "Die Schwierigkeit passt sich automatisch an Ihre Genauigkeit an. {count} Fragen pro Sitzung.",
  catNote: "ℹ️ Hinweis: Der echte TOEFL iBT ist ein linearer (nicht adaptiver) Test. Dieser Practice CAT ist ein Lernwerkzeug, das die Schwierigkeit an Ihre Leistung anpasst, damit Sie Ihr Niveau schnell einschätzen können – er ist keine Simulation des echten Prüfungsformats.",
  catSelectSection: "Abschnitt auswählen",
  catStartBtn: "Adaptiven Test starten",
  catLoading: "Nächste Frage wird geladen...",
  catNoMore: "Keine weiteren Fragen verfügbar",
  catComplete: "Adaptiver Test abgeschlossen",
  catAccuracy: "Genauigkeit",
  catFinalLevel: "Endgültiger Schwierigkeitsgrad",
  catTryAgain: "Erneut versuchen",
  catViewResults: "Ergebnisse anzeigen",
  catNext: "Weiter",
  catExplanation: "Erklärung",
  catStop: "Stopp",
  catPlayAudio: "Audio abspielen",
  catReadingPassage: "Lesepassage",
  pricingSaveBadge: "30% Rabatt",
  pricingPerMonth: "Monat",
  pricingSSL: "Sicherer Checkout",
  pricingCard: "Kartenzahlung",
  pricingPaymentSuccess: "Premium erfolgreich aktiviert!",
  pricingCurrentPlan: "Aktueller Plan",
  grammarSystematic: "Systematisches Grammatiklernen",
  grammarBookDesc: "Lernen Sie 20 wichtige TOEFL-Grammatikthemen mit praktischen Beispielen und Übungen.",
  grammarTestAfter: "Testen Sie es direkt nach dem Lernen!",
  grammarTestAfterDesc: "Überprüfen Sie, wie Grammatikpunkte in echten TOEFL-Fragen vorkommen.",
  grammarMockTest: "Probetest",
  grammarDoneTitle: "Grammatikstudium abgeschlossen?",
  grammarDoneDesc: "Wenden Sie das Gelernte in einem Probetest an. Falsche Antworten werden automatisch zur Überprüfung gespeichert.",
  grammarStartRC: "Lese-Probetest starten",
  grammarPracticePart5: "Lese-Grammatikübung",
  leaderboardMyRank: "🏅 Mein Rang: #{rank}",
  speakingPageSub: "{count}+ kostenlose Sprechübungen — Listen and Repeat · Interview",
  speakingPageTitle: "TOEFL Sprechübungen 2026 – {count}+ kostenlose Aufgaben & Musterantworten | Power TOEFL",
  speakingAllTasks: "Alle",
  speakingNoPrompts: "Noch keine Sprechübungen",
  speakingNoPromptsSub: "Die Aufgaben werden generiert. Bitte schauen Sie bald wieder vorbei.",
  speakingResponseTime: "Antwortzeit",
  writingPageSub: "{count}+ kostenlose Schreibaufgaben — Build a Sentence · Email · Academic Discussion",
  writingPageTitle: "TOEFL Schreibübungen 2026 – {count}+ kostenlose Aufgaben | Power TOEFL",
  writingAllTasks: "Alle",
  writingNoPrompts: "Noch keine Schreibaufgaben",
  writingNoPromptsSub: "Die Aufgaben werden generiert. Bitte schauen Sie bald wieder vorbei.",
  testPrevious: "Zurück",
  testNext: "Weiter",
  testQuestion: "Frage",
  testQuestionPrompt: "Lesen Sie die Frage und wählen Sie die beste Antwort.",
  testMarkAnswer: "Bitte markieren Sie die Nummer der besten Antwort.",
  testSelect: "Auswählen",
  testShowAnswer: "Antwort und Erklärung anzeigen",
  testCorrect: "Richtig!",
  testIncorrect: "Falsch.",
  testSubmit: "Test einreichen",
  testContinue: "Weiter",
  resultsTitle: "{0} Testergebnis",
  resultsTimeUsed: "Benötigte Zeit: {0} Min. {1} Sek.",
  resultsEstimatedScore: "Geschätzte Punktzahl (von 30)",
  resultsCorrect: "Richtig",
  resultsIncorrect: "Falsch",
  vocabSynonyms: "Synonyme",
  vocabAntonyms: "Antonyme",
  tipsLCButton: "Hörstrategie",
  tipsRCButton: "Lesestrategie",
  practiceRelatedLinks: "📌 Verwandter Lerninhalt",
  practiceOtherParts: "Andere Teile",
  practiceMockTestCTA: "Üben Sie mit einem vollständigen Probetest",
  practiceTipsLink: "Teilspezifische Strategien anzeigen",
  practiceGrammarLink: "Grammatik lernen",
  practiceNotFound: "Teil nicht gefunden.",
  practiceQuestionType: "Fragetyp",
  practiceTips: "💡 Strategietipps",
  practiceExamples: "📝 Beispielfragen",
  practiceIntro: "📋 Teilübersicht",
  practiceCommonTypes: "📊 Häufige Fragetypen",
  practiceStrategy: "🎯 Schlüsselstrategien",
  practiceRecommendedFor: "👤 Empfohlen für",
  practiceFAQ: "❓ FAQ",
  practiceCTA: "Jetzt üben",
  practiceCTADesc: "Sie können Teil {0} in einer realistischen Testumgebung üben.",
  practiceStartTest: "{0} Probetest starten",
  practiceQuestions: "Fragen",
  practicePartSelect: "Teil auswählen",
  roundsTitle: "Probetestrunden",
  roundLabel: "TOEFL Probetest",
  roundUnit: "Runde",
  comingSoon: "Demnächst verfügbar",
  testLoginPrompt: "Notizen zu falschen Antworten & Fortsetzungsfunktionen erfordern eine Anmeldung.",
  testGoogleLogin: "Starten Sie mit Google in 3 Sekunden",
  roundSelect: "Wählen Sie eine andere Runde",
  testAnswered: "Beantwortet",
  testSubmitTitle: "{0} Test abschicken?",
  testSubmitDesc: "Sie haben {1} von {0} Fragen beantwortet.",
  testUnanswered: "{0} unbeantwortete Fragen.",
  testCannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden.",
  testSubmitBtn: "Abschicken",
  resultsAccuracy: "Genauigkeit",
  resultsReview: "Antworten überprüfen",
  resultsYourAnswer: "Ihre Antwort: {0}",
  resultsCorrectAnswer: "Richtige Antwort: {0}",
  resultsNoAnswer: "Keine Antwort",
  resultsHome: "Startseite",
  resultsWrongNotes: "Falsche Antworten",
  resultsRetry: "Wiederholen",
  resultsShare: "Ergebnisse teilen",
  resultsShareText: "Mein geschätzter TOEFL {0} Score ist {1}! ({2}/{3} richtig, {4}% Genauigkeit) Testen Sie Ihre Fähigkeiten kostenlos mit Power TOEFL!",
  resultsShareCopied: "Ergebnisse in die Zwischenablage kopiert!",
  resultsNoResults: "Keine Testergebnisse.",
  resultsGoHome: "Zur Startseite",
  resultsSaved: "{0} falsche Antworten wurden in Ihren falschen Antworten gespeichert",
  wrongAnswersTitle: "Falsche Antworten",
  wrongAnswersSaved: "Gespeicherte Elemente",
  wrongAnswersHome: "Startseite",
  wrongAnswersPracticeAll: "Alle üben",
  wrongAnswersAll: "Alle",
  wrongAnswersNoItems: "Noch keine falschen Antworten. Machen Sie zuerst einen Test!",
  wrongAnswersYourAnswer: "Ihre Antwort: {0}",
  wrongAnswersCorrectIs: "Richtige Antwort: {0}",
  wrongAnswersReviewed: "Überprüft",
  wrongAnswersRemoved: "Aus den falschen Antworten entfernt",
  wrongAnswersPracticeMode: "Übungsmodus",
  wrongAnswersCorrectMsg: "Richtig!",
  wrongAnswersIncorrectMsg: "Falsch. Richtige Antwort: {0}",
  wrongAnswersNextQuestion: "Nächste Frage",
  wrongAnswersFinish: "Übung beenden",
  wrongAnswersExitPractice: "Übung verlassen",
  wrongAnswersPracticeComplete: "Übung abgeschlossen!",
  wrongAnswersNoPractice: "Keine falschen Antworten zum Üben",
  wrongAnswersLimitNotice: "Es werden nur die letzten 500 falschen Antworten angezeigt.",
  privacyPageTitle: "Datenschutzbestimmungen — Power TOEFL",
  privacyPageDesc: "Datenschutzbestimmungen von Power TOEFL.",
  privacyHeading: "Datenschutzbestimmungen",
  privacyLastUpdated: "Zuletzt aktualisiert: 29. März 2026",
  privacyS1Title: "1. Gesammelte persönliche Informationen",
  privacyS1Body: "Power TOEFL sammelt Ihre E-Mail-Adresse, Ihren Namen und Ihr Profilbild, wenn Sie sich mit Google anmelden, um den Dienst bereitzustellen. Wenn Sie Zahlungen tätigen, werden Zahlungsinformationen über Zahlungsanbieter (Dodo Payments/PayPal) verarbeitet; wir speichern keine Kreditkartendaten direkt.",
  privacyS2Title: "2. Verwendungszweck",
  privacyS2Body: "Gesammelte persönliche Daten werden ausschließlich zum Speichern falscher Antworten, zur Verfolgung des Lernfortschritts, zur Verwaltung von Abonnements, für den Kundensupport und zur Verbesserung des Dienstes verwendet.",
  privacyS3Title: "3. Datenaufbewahrung und -löschung",
  privacyS3Body: "Wenn ein Benutzer sein Konto löscht, werden persönliche Daten sofort gelöscht. Zahlungsaufzeichnungen werden gemäß den steuerrechtlichen Anforderungen bis zu 5 Jahre aufbewahrt und dann gelöscht. Sofern andere Gesetze eine Aufbewahrung erfordern, werden die Daten für den erforderlichen Zeitraum aufbewahrt und dann gelöscht.",
  privacyS4Title: "4. Offenlegung gegenüber Dritten",
  privacyS4Body: "Zur Zahlungsabwicklung geben wir die minimal erforderlichen Informationen (E-Mail) an Dodo Payments (Merchant of Record) oder PayPal weiter. Wir geben Benutzerdaten nicht an andere Dritte weiter, es sei denn, dies ist gesetzlich vorgeschrieben.",
  privacyS5Title: "5. Cookies & Anzeigen",
  privacyS5Body: "Diese Seite schaltet Anzeigen über Google AdSense und verwendet dafür Cookies. Cookies können in Ihren Browsereinstellungen verwaltet werden. Details zu den Werbe-Cookies von Google finden Sie in der Datenschutzerklärung von Google.",
  privacyS6Title: "6. Internationale Datenübermittlung",
  privacyS6Body: "Dieser Dienst verwendet Server im Ausland, und Daten können zur Zahlungsabwicklung international übertragen werden. Wir schützen personenbezogene Daten mit geeigneten Sicherheitsmaßnahmen.",
  privacyS7Title: "7. Nutzerrechte",
  privacyS7Body: "Nutzer können jederzeit den Zugriff auf ihre personenbezogenen Daten, deren Korrektur oder Löschung verlangen. Einwohner der EU/EWR haben zusätzliche Rechte gemäß der DSGVO. Um Ihr Konto zu löschen, melden Sie sich bitte ab und kontaktieren Sie uns.",
  privacyS8Title: "8. Kontakt",
  privacyS8Body: "Für Datenschutzanfragen kontaktieren Sie bitte skdaks0731@gmail.com.",
  termsPageTitle: "Nutzungsbedingungen — Power TOEFL",
  termsPageDesc: "Power TOEFL Nutzungsbedingungen.",
  termsHeading: "Nutzungsbedingungen",
  termsLastUpdated: "Zuletzt aktualisiert: 29. März 2026",
  termsS1Title: "1. Serviceübersicht",
  termsS1Body: "Power TOEFL ist eine Online-Lernplattform zur TOEFL-Vorbereitung, betrieben von ddookddak (unserem eingetragenen rechtlichen Firmennamen). Wir bieten kostenlose Funktionen und kostenpflichtige Premium-Abonnements (Pro/Lifetime) an, die Mock-Tests, teilspezifisches Training, KI-Fragengenerierung und Notizen zu falschen Antworten umfassen.",
  termsS2Title: "2. Teilnahmeberechtigung",
  termsS2Body: "Der Dienst ist für Nutzer ab 14 Jahren verfügbar. Einige Funktionen (Notizen zu falschen Antworten, KI-Training usw.) erfordern eine Google-Kontenanmeldung, und Premium-Funktionen erfordern ein kostenpflichtiges Abonnement.",
  termsS3Title: "3. Geistiges Eigentum",
  termsS3Body: "Der Inhalt dieser Website (Fragen, Design, Code usw.) ist Eigentum von Power TOEFL. TOEFL ist eine eingetragene Marke von ETS; diese Website ist nicht mit ETS verbunden.",
  termsS4Title: "4. Kostenpflichtige Dienste & Zahlungen",
  termsS4Body: "Premium-Abonnements werden über externe Zahlungsdienstleister (Dodo Payments/PayPal) abgewickelt. Abonnementgebühren werden je nach gewähltem Plan (monatlich/jährlich/lebenslang) automatisch oder als Einmalzahlung abgerechnet. Preise können Mehrwertsteuer enthalten; der endgültige Betrag wird an der Kasse angezeigt. Einzelheiten zu Rückerstattungen finden Sie in den separaten Rückerstattungsrichtlinien.",
  termsS5Title: "5. Haftungsausschluss",
  termsS5Body: "Die von diesem Dienst bereitgestellten Mock-Testergebnisse und Studienmaterialien dienen nur als Referenz und garantieren keine tatsächlichen TOEFL-Ergebnisse. Wir haften nicht für direkte oder indirekte Schäden, die sich aus der Nutzung des Dienstes ergeben.",
  termsS6Title: "6. Verbotenes Verhalten",
  termsS6Body: "Sie dürfen Fragen ohne Genehmigung nicht kopieren oder verbreiten, das System überlasten, Konten mit anderen teilen oder andere illegale Aktivitäten ausführen.",
  termsS7Title: "7. Dienständerungen & -aussetzung",
  termsS7Body: "Der Betreiber kann den Dienst ohne vorherige Ankündigung ändern oder aussetzen und ist nicht zur Entschädigung verpflichtet.",
  termsS8Title: "8. Abonnementkündigung",
  termsS8Body: "Kostenpflichtige Abonnements können jederzeit gekündigt werden. Nach der Kündigung bleiben Premium-Funktionen bis zum Ende des bezahlten Zeitraums verfügbar, danach wird das Konto auf den kostenlosen Plan zurückgesetzt.",
  termsS9Title: "9. Änderungen der Bedingungen",
  termsS9Body: "Diese Bedingungen können bei Bedarf aktualisiert werden; Änderungen werden auf der Website veröffentlicht. Die fortgesetzte Nutzung des Dienstes nach Änderungen stellt die Annahme der aktualisierten Bedingungen dar.",
  refundPageTitle: "Rückerstattungsrichtlinie — Power TOEFL",
  refundPageDesc: "Rückerstattungsrichtlinie für Power TOEFL Premium-Abonnements.",
  refundHeading: "Rückerstattungsrichtlinie",
  refundLastUpdated: "Zuletzt aktualisiert: 15. April 2026",
  refundS1Title: "1. Grundsatz der Rückerstattung",
  refundS1Body: "Aufgrund der Natur digitaler Produkte sind Rückerstattungen grundsätzlich nicht verfügbar.",
  refundS2Title: "2. Ausnahmefälle für Rückerstattung",
  refundS2Body: "In Ausnahmefällen kann eine Rückerstattung jedoch gewährt werden, wenn dies gesetzlich erforderlich ist, bei Doppelbelastung, Nichtbereitstellung der Leistung oder schwerwiegenden technischen Störungen.",
  refundS3Title: "3. Kontaktweg",
  refundS3Body: "Für Anfragen zur Rückerstattung nutzen Sie bitte den Support-/Feedback-Kanal. Kontakt: skdaks0731@gmail.com",
  refundS4Title: "4. Kündigung des Abonnements",
  refundS4Body: "Kostenpflichtige Abonnements können jederzeit gekündigt werden. Nach der Kündigung bleibt der Premium-Zugang bis zum Ende des aktuellen Abrechnungszeitraums bestehen; danach fallen keine weiteren Gebühren an.",
  refundS5Title: "",
  refundS5Body: "",
  refundS6Title: "",
  refundS6Body: "",
  grammarChapter: "Kapitel",
  aiPracticeTitle: "Unbegrenzt KI TOEFL Fragen generieren – wählen Sie Teil & Schwierigkeitsgrad für sofortige Fragen | Power TOEFL",
  aiPracticeDesc: "Wählen Sie einen Teil und einen Schwierigkeitsgrad aus, und die KI generiert sofort TOEFL-Fragen. Kostenlose Übungsfragen mit automatischen Erklärungen – erhalten Sie jeden Tag neue Fragen.",
  aiPracticeH1: "✨ KI TOEFL Fragen-Generator",
  aiPracticeSub: "Die KI generiert TOEFL-Fragen in Echtzeit mit Ihrem gewählten Schwierigkeitsgrad.",
  aiPartLabel: "Teil",
  aiDiffLabel: "Schwierigkeitsgrad",
  aiBeginner: "Anfänger (1.0–2.5)",
  aiIntermediate: "Mittelstufe (3.0–4.5)",
  aiAdvanced: "Fortgeschritten (5.0–6.0)",
  aiGenerate: "Fragen generieren",
  aiGenerating: "Generiere...",
  aiRemainingToday: "{0} diesen Monat übrig",
  aiLimitReached: "Sie haben alle KI-Guthaben für diesen Monat aufgebraucht",
  aiLimitUpgrade: "Kaufen Sie mehr Guthaben oder upgraden Sie Ihren Plan!",
  aiUpgrade: "Upgrade",
  aiListenPrompt: "🔊 Bei Hörverständnisaufgaben beim Beantworten zuhören",
  aiPlayAudio: "Audio abspielen",
  aiStopAudio: "Stop",
  aiCorrect: "✅ Richtig!",
  aiWrong: "❌ Falsch.",
  aiCorrectAnswer: "Richtige Antwort: {0}",
  aiPrev: "Zurück",
  aiNext: "Weiter",
  aiNewQuestions: "Neue Fragen",
  aiEmptyTitle: "Fragen mit KI generieren",
  aiEmptyDesc: "Teil und Schwierigkeitsgrad auswählen und dann auf „Fragen generieren“ klicken.",
  aiLoadingMain: "KI generiert und validiert Fragen...",
  aiLoadingSub: "Dauert ca. 10–20 Sekunden",
  statsTotalQuizzes: "Gesamtzahl der Tests",
  statsTotalQuestions: "Gesamtzahl der Fragen",
  statsAccuracy: "Genauigkeit",
  statsWrongSummary: "Zusammenfassung der falschen Antworten",
  statsViewAll: "Falsche Antworten ansehen",
  statsReviewed: "Überprüft",
  statsPending: "Ausstehende Überprüfung",
  statsTopicAccuracy: "Genauigkeit nach Grammatikthema",
  statsAttempts: "{0} Versuche",
  statsEmpty: "Noch keine Lernaufzeichnungen. Versuchen Sie ein Grammatik-Quiz!",
  statsStartGrammar: "Grammatikstudium beginnen",
  testLCTitle: "Kostenloser TOEFL Leseverständnis-Probetest – akademische Texte lesen | 2026",
  testLCDesc: "Kostenloser, aktualisierter TOEFL Leseverständnis-Probetest 2026. 20 Fragen basierend auf akademischen Texten. Falsche Antworten werden automatisch gespeichert.",
  testRCTitle: "Kostenloser TOEFL Hörverständnis-Probetest – Konversationen & Vorlesungen | 2026",
  testRCDesc: "Kostenloser, aktualisierter TOEFL Hörverständnis-Probetest 2026. 28 Fragen zu Konversationen und Vorlesungen. KI-Erklärungen und Hinweise zu falschen Antworten werden bereitgestellt.",
  reviewTitle: "Heutige Überprüfung",
  reviewDesc: "Intelligentes Überprüfungssystem basierend auf der Ebbinghausschen Vergessenskurve",
  reviewSubtitle: "Überprüfen Sie zu den optimalen Zeitpunkten gemäß der Vergessenskurve",
  reviewRemaining: "Verbleibende Überprüfungen",
  reviewProgress: "Überprüfungsfortschritt",
  reviewCompleted: "🎉 Die heutige Überprüfung ist abgeschlossen!",
  reviewCompletedDesc: "{0} Fragen überprüft",
  reviewEmpty: "Keine Überprüfungselemente für heute",
  reviewEmptyDesc: "Entweder haben Sie alle Überprüfungen abgeschlossen oder es gibt noch keine falschen Antworten.",
  reviewStage: "Stufe {0}",
  reviewNextInterval: "{0}-Tages-Intervall",
  reviewCorrect: "Richtig! Gehen Sie zur nächsten Stufe über.",
  reviewWrong: "Falsch. Neustart bei Stufe 1.",
  reviewNextReview: "Nächste Überprüfung: in {0} Tagen",
  reviewResetMsg: "Falsch — Sie werden in 1 Tag erneut überprüfen.",
  reviewNext: "Nächste Frage",
  reviewFinish: "Beenden",
  reviewHowItWorks: "Ebbinghaus-Überprüfungsmethode",
  reviewDaysLater: "{0} Tage später",
  reviewExplanation: "Falsch beantwortete Elemente werden in Intervallen von 1 → 3 → 7 → 14 → 30 → 60 Tagen überprüft. Richtige Antworten gehen zur nächsten Stufe über; falsche Antworten kehren zur Stufe 1 zurück.",
  notifTitle: "Benachrichtigungen",
  notifEmpty: "Keine neuen Benachrichtigungen",
  notifMarkAllRead: "Alle als gelesen markieren",
  timeJustNow: "Gerade eben",
  timeMinutes: "Vor {0} Minuten",
  timeHours: "Vor {0} Stunden",
  timeDays: "Vor {0} Tagen",
  scoreCardEstimated: "Geschätzte Punktzahl",
  scoreCardCorrect: "Richtig",
  scoreCardIncorrect: "Falsch",
  scoreCardAccuracy: "Genauigkeit",
  pushTitle: "Studienbenachrichtigungen erhalten",
  pushDesc: "Wir benachrichtigen dich über Lernzeiten, Lernserien und mehr.",
  pushEnable: "Benachrichtigungen aktivieren",
  navReview: "Wiederholen",
  navStats: "Statistiken",
  navSubscription: "Abonnement",
  roundDetailHeading: "TOEFL Vollständiger Probetest",
  roundDetailOtherRounds: "Weitere Runden ansehen",
  roundSuffix: "Runde",
  footer7DayPlan: "7-Tage-Lernplan",
  footerTrapPatterns: "Fallenmuster",
  aiQuizTitle: "🤖 KI-generierte Übungsfragen",
  aiQuizDesc: "KI-generierte TOEFL Grammatikfragen",
  aiQuizGenerateDesc: "KI generiert in Echtzeit 5 TOEFL-ähnliche Grammatikfragen.",
  aiQuizGenerate: "KI-Fragen generieren",
  aiQuizGenerating: "🤖 KI generiert Fragen...",
  aiQuizGeneratingTime: "Dauert etwa 5–10 Sekunden",
  aiQuizNew: "Neue Fragen",
  aiQuizStats: "Kumulative Statistiken:",
  aiQuizTimes: "Mal",
  aiQuizCheckAnswers: "Antworten überprüfen",
  aiQuizPerfect: "🎉 Perfekt!",
  aiQuizCorrectCount: "Richtig",
  aiQuizSaving: "Ergebnisse werden gespeichert...",
  aiQuizTryNew: "Neue Fragen ausprobieren",
  aiQuizError: "Fehler beim Generieren der KI-Fragen. Bitte versuche es erneut.",
  tipsDetailStrategy: "Detaillierte Strategie",
  subLoginRequired: "Anmeldung erforderlich.",
  grammarHome: "Startseite",
  grammarExamples: "Beispielsätze",
  grammarTestKnowledge: "📝 Wissenstest",
  grammarTestKnowledgeDesc: "Testen Sie Ihr Wissen mit echten Fragen zur gelernten Grammatik!",
  grammarCheckAnswers: "Antworten prüfen",
  grammarPerfect: "🎉 Perfekt!",
  grammarCorrectCount: "Richtig",
  grammarMockCTA: "🔥 Überprüfen Sie Ihre Fähigkeiten mit einem vollständigen Probetest!",
  grammarMockCTADesc: "RC 100-Fragen-Vollprobetest + automatische Notizen zu falschen Antworten",
  grammarStartRCMock: "RC-Probetest starten",
  grammarPractice5: "Leseübung",
  grammarTestInPractice: "In der Praxis testen!",
  grammarTestInPracticeDesc: "Sehen Sie, wie Grammatikpunkte in echten TOEFL-Tests vorkommen.",
  grammarRelated: "📚 Verwandte Grammatik",
  wrongAnswersGrammarAI: "Grammatik-KI",
  streakDays: "Tage",
  streakLabel: "Lernserie",
  streak7: "7-Tage-Serie!",
  streak14: "2-Wochen-Serie!",
  streak30: "Großartig! 30-Tage-Serie!",
  reviewItems: "Elemente",
  reviewTodayLabel: "Heutige Wiederholungsfragen",
  reviewGoLabel: "📚 Wiederholung starten →",
  loadingQuestions: "Fragen werden geladen...",
  tipsCoreTips: "Kerntipps",
  tipsStrategy: "Strategie",
  tipsCTA: "Wenden Sie diese Strategien in der Praxis an!",
  testScrollHint: "Scrollen, um Frage und Optionen anzuzeigen",
  testPart1Label: "Akademisches Lesen",
  testPart2Title: "Konversationen",
  testPart2Desc: "Hören Sie sich das Audio an und wählen Sie die richtige Antwort",
  testPart3Label: "Vorlesungen",
  creditBuyBtn: "Guthaben kaufen",
  creditBuyTitle: "KI-Credits kaufen",
  creditBuyDesc: "Kaufen Sie zusätzliche Credits für KI-Feedback zu Sprechen/Schreiben und KI-Übungen.",
  creditBuyError: "Zahlung konnte nicht eingeleitet werden",
  creditBuyNote: "PayPal-Zahlung. Credits werden sofort nach Abschluss der Zahlung hinzugefügt.",
  creditUnit: "Credits",
  vocabFlashcardStart: 'Karteikarten starten',
  vocabFlashcardStop: 'Karteikarten stoppen',
  vocabFlashcardEmpty: 'Fügen Sie zuerst Wörter hinzu, um Karteikarten zu starten.',
  vocabFlashcardSpeed: 'Geschwindigkeit',
  vocabFlashcardSpeedSlow: 'Langsam',
  vocabFlashcardSpeedNormal: 'Normal',
  vocabFlashcardSpeedFast: 'Schnell',
  vocabFlashcardShuffle: 'Mischen',
  vocabFlashcardPrev: 'Zurück',
  vocabFlashcardNext: 'Weiter',
  vocabFlashcardFlip: 'Umdrehen',
  vocabFlashcardProgress: '{current} / {total}',
};

export default de;
